import type {expedientsRouteApi} from "./-route-api";

import {listExpedientsSearchSchema as applicationSearchSchema} from "@project/application/sales/expedients";

// Collection presentation defaults to Active; the public Application query
// continues to support its canonical absent-state/all-state contract.
export const listExpedientsSearchSchema = applicationSearchSchema.extend({
  state: applicationSearchSchema.shape.state.removeCatch().default("ACTIVE").catch("ACTIVE"),
});
export type {
  ListExpedientsSearch,
  ListExpedientsSearchInput,
} from "@project/application/sales/expedients";

export type ExpedientsNavigateFn = ReturnType<typeof expedientsRouteApi.useNavigate>;
